import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
      // 送信データ形式をJSONに設定
  },
  timeout: 10000, // タイムアウトを設定（10秒）
});

// リクエストインターセプター（必要に応じて認証トークンなどのヘッダーを追加）
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// レスポンスインターセプター（エラーハンドリング）
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Authentication error');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
